<template>
  <v-card class="rounded-card">
    <v-card-title class="font-weight-bold">
      Edição de cotação
    </v-card-title>
    <v-card-text>
      <div v-if="loadingCotacao">
        <px-circular-loading/>
      </div>
      <div v-if="cotacao" class="text--primary">
        <v-row dense>
          <v-col cols="12">
            <px-situacao-cotacao-icon :situacao="cotacao.situacao"/>
            {{ cotacao.identificador }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-icon>mdi-domain</v-icon>
            {{ cotacao.comprador.pessoa.nome }}
          </v-col>
        </v-row>
        <v-row dense>
          <v-col class="d-flex" cols="12" sm="12" md="6">
            <px-select-enum v-model="cotacao.tipoFrete"
                            label="Tipo de frete"
                            class="rounded-tag-small"
                            :items="tiposFretes"/>
          </v-col>
          <v-col class="d-flex" cols="12" sm="12" md="6">
            <px-date-picker label="Prazo de entrega"
                            input-class="rounded-tag-small"
                            v-model="cotacao.prazoEntrega"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col class="d-flex" cols="12" sm="12" md="6">
            <px-date-picker label="Prazo de resposta"
                            input-class="rounded-tag-small"
                            v-model="cotacao.validade"/>
          </v-col>
          <v-col class="d-flex" cols="12" sm="12" md="6">
            <px-select-enum v-model="cotacao.formaPagamento" :items="formasPagamentos"
                            class="rounded-tag-small"
                            label="Forma pagamento"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col class="d-flex" cols="12">
            <px-autocomplete-prazo-pagamento
              class="rounded-tag-small"
              v-model="cotacao.prazoPagamento"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-textarea
              outlined
              rows="3"
              v-model="cotacao.observacao"
              name="input-7-4"
              label="Observações"
              counter="1500"
              class="rounded-tag-small"
            />
          </v-col>
        </v-row>
        <v-divider />
        <v-row dense>
          <v-col cols="12">
            <div class="font-weight-bold">
              Produtos
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-simple-table
              class="ma-4 produtos-table">
              <template v-slot:default>
                <tbody>
                <tr v-for="(produto) in cotacao.produtos"
                    :key="produto.id"
                    style="height: 60px">
                    <td class="px-1" style="min-width: 280px">
                      <px-span-tooltip v-if="checkCodigo(produto.produto)"
                                  top
                                  :text="labelCodigo(produto.produto)"
                                  tooltip="Código interno"/>
                    {{ produto.produto.descricao }}
                  ({{ produto.quantidade | number('0.00') }} {{ produto.unidadeMedida.descricao }})
                    </td>
                    <td class="px-1" style="min-width: 380px">
                      <v-textarea
                        outlined
                        auto-grow
                        dense
                        hide-details
                        v-model="produto.especificacaoProduto"
                        label="Especificação"
                        counter="1500"
                        rows="1"
                        class="rounded-tag-small"/>
                    </td>
                    <td class="px-1" style="min-width: 20px">
                      <px-cadastro-produto-observacoes
                        :produto="produto"
                        :small="false"
                        is-edicao/>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <div class="font-weight-bold body-2">
              Finalidade da compra
            </div>
            <v-radio-group
              row dense
              v-model="cotacao.finalidadeCompra"
              class="d-flex"
              >
              <v-radio
                v-for="finalidade in finalidades"
                :key="finalidade.key"
                :label="finalidade.description"
                :value="finalidade.key"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
    <v-card-actions v-if="!loadingCotacao">
      <div class="actions">
        <v-btn color="primary"
              class="normal-btn-text rounded-tag-small"
              :loading="loading"
              @click="onClickSave">
          Salvar
        </v-btn>
        <v-btn text class="normal-btn-text" @click="onClickCancel">
          Cancelar
        </v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import CotacaoService from '@/modules/cotacao/cotacao-service';
import {
  FormaPagamento, SituacaoCotacao, TipoFrete, FinalidadeCompra,
} from 'px-business-components';

export default {
  data() {
    return {
      idCotacao: this.$route.params.id,
      loadingCotacao: false,
      loading: false,
      cotacao: null,
      finalidades: FinalidadeCompra.values,
      tiposFretes: TipoFrete.values,
      formasPagamentos: FormaPagamento.values,
    };
  },
  computed: {
    checkCodigo() {
      return item => item.codigo;
    },
    labelCodigo() {
      return item => `${item.codigo} - `;
    },
    isAberta() {
      return item => item.situacao
        === SituacaoCotacao.keys.ABERTA.key;
    },
    produtosToEdit() {
      return this.cotacao.produtos.filter(prod => this.isAberta(prod));
    },
  },
  methods: {
    getCotacao() {
      this.loadingCotacao = true;
      CotacaoService.getCotacao(this.idCotacao)
        .then((response) => {
          this.cotacao = response.data;
        })
        .finally(() => {
          this.loadingCotacao = false;
        });
    },
    onClickCancel() {
      this.$router.push({ name: 'main.cotacoes' });
    },
    save() {
      this.loading = true;
      CotacaoService.updateCotacao(this.cotacao)
        .then(() => {
          this.$toast('Cotação atualizada com sucesso', { color: 'success' });
          this.onClickCancel();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickSave() {
      this.save();
    },
  },
  created() {
    this.getCotacao();
  },
};
</script>
<style scoped>
.actions {
  padding-left: 0.4rem;
  padding-bottom: 0.7rem;
}
</style>
